import React, { Component } from 'react';
import { Link } from '~/UI/Button';
import Heading from '~/UI/Heading/Heading';

import styles from './styles.less';

export default class NotFoundErrorPage extends Component {
	render() {
		return (
			<div className={styles.content}>
				<div className={styles.in}>
					<Heading>404</Heading>
					<p>
						We can’t find the page you’re looking for.
						<br />
						<br />
						Here are a few links that may be helpful:
						<br />
						<Link to='/product-groups/'>Search</Link>
						<i className={styles.space}> • </i>
						<Link to='/product-groups/#product-list'>Product list</Link>
						<i className={styles.space}> • </i>
						<Link href='https://www.cogvio.com/'>www.cogvio.com</Link>
					</p>
				</div>
			</div>
		);
	}
}
